import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import { ShieldCheck, Lock, Clock } from 'react-bootstrap-icons';
import { states } from './constants';
import { useState } from 'react';
import axios from 'axios'

export function UnlockQuote({ show, setShowQuote, onHide, bodyParts = [], setLeadId }) {

    const [form, setForm] = useState({})
    const [errors, setErrors] = useState({})
    const setField = (field,value) =>{
        setForm({
         ...form,
         [field]:value
        })

        if(!!errors[field])
        setErrors({
         ...errors,
         [field]:null
        })
    }

    const validateForm = () =>{
     const { firstname, lastname, phone, st}  = form
     const newErrors = {}


      if(!firstname || firstname === "") newErrors.firstname = 'Please enter your First name.'

      if(!lastname || lastname === "") newErrors.lastname = 'Please enter your Last name.'

      if(!phone || phone === "") newErrors.phone = 'Please enter your Phone number.'
      else if (!/^[0-9]+$/.test(phone)) newErrors.phone = 'Please enter a valid Phone number'
      else if (phone.length < 10) newErrors.phone = 'Phone number is too short'

      if(!st) newErrors.st = 'Please select your state.'

      return newErrors
    }
    
    const handleSubmit = async (event) => {
     event.preventDefault();

     const formErrors = validateForm()
     if(Object.keys(formErrors).length > 0){
        setErrors(formErrors)
     } else{
        setShowQuote(true);
        try {
          const res = await axios.post(`${process.env.REACT_APP_CORE_API}/lead`, {
            firstName: form.firstname,
            lastName: form.lastname,
            phone: form.phone,
            state: form.st,
            status: 'Inquiry',
            injuries: bodyParts.map(p => ({ bodyPart: p.bodyPart, injuryType: 'Injury', severity: 1 }))
          });
          setLeadId?.(res.data.id);
        } catch (err) {
          console.error('Failed to submit lead:', err);
        }
      }
    }
    
    

    



    return (
        <Modal show={show} onHide={onHide} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton onClick={onHide} className="unlock-quote-header">
                <Modal.Title id="contained-modal-title-vcenter">
                    <Lock size={20} className="me-2" style={{ color: '#007EF2' }} />
                    Unlock Your Free Quote
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <div className="trust-badges mb-4">
                        <div className="trust-badge">
                            <ShieldCheck size={16} />
                            <span>100% Free</span>
                        </div>
                        <div className="trust-badge">
                            <Lock size={16} />
                            <span>Secure & Private</span>
                        </div>
                        <div className="trust-badge">
                            <Clock size={16} />
                            <span>No Obligation</span>
                        </div>
                    </div>
                    <Form>
                        <Form.Group className="mb-3" controlId="validation01">
                            <Row>
                                <Col>
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    placeholder="Enter First Name" 
                                    required 
                                    value = {form.firstname}
                                    isInvalid = {!!errors.firstname}
                                    onChange={e => setField('firstname',e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid"> {errors.firstname} </Form.Control.Feedback>
                                </Col>
                                <Col>
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    placeholder="Enter Last Name"
                                    required
                                    value = {form.lastname}
                                    isInvalid = {!!errors.lastname}
                                    onChange={e => setField('lastname',e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid"> {errors.lastname} </Form.Control.Feedback>
                                </Col>
                            </Row>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId = 'validation02'>
                            <Form.Label>Phone</Form.Label>
                            <Form.Control 
                            type="text" 
                            placeholder="Enter Phone"
                            required
                            maxLength = {10}
                            value = {form.phone}
                            isInvalid = {!!errors.phone}
                            onChange={e => setField('phone',e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid"> {errors.phone} </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId = 'validation03'>
                            <Form.Label>State</Form.Label>
                            <Form.Select aria-label="State"
                            value = {form.st}
                            isInvalid = {!!errors.st}
                            required
                            onChange={e => setField('st',e.target.value)}
                            >
                            <option hidden>Select State</option>
                                {states.map((state, index) => {
                                    return (<option value={state.name} key={index}>{state.abbreviation}</option>)
                                })}  
                            </Form.Select>
                            <Form.Control.Feedback type="invalid"> {errors.st} </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </Container>
            </Modal.Body>

            <Modal.Footer className="unlock-quote-footer">
                <Button className="qmi-btn-accent w-100" onClick={handleSubmit}>
                    Unlock My Free Quote
                </Button>
                {/* <small className="text-muted mt-2 text-center d-block">
                    Your information is kept confidential and will never be sold.
                </small> */}
            </Modal.Footer>
        </Modal>
    );
}
    